export default "__VITE_ASSET__DcoEuvIt__"